<mat-sidenav-container autosize [ngClass]="{ isMobile: mobileQuery }">
  <mat-sidenav #sidenav fixedTopGap="56" mode="side" [ngClass]="{ expanded: isExpanded }" opened="isExpanded">
    <div class="sidenav-header">
      <div class="sidenav-header-img">
        <img src="assets/images/logo_min.jpg" alt="SIGP" class="logo-min" />
        <img src="assets/images/logo.jpg" alt="SIGP" class="logo" />
      </div>

      <!-- Collapse menu -->
      <button mat-icon-button (click)="toggleMenu()" class="toggle-menu" [ngClass]="{ rotated: isExpanded }">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <mat-accordion class="app-nav-accordion">
      <div mat-line class="titulo-seccion-menu">
        <span>Herramientas</span>
      </div>

      <mat-nav-list>
        <a mat-list-item routerLink="/dashboard/home" routerLinkActive="mat-active" class="menu-link">
          <mat-icon matListIcon>analytics</mat-icon>
          <p mat-line>
            <span>Dashboard</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item routerLink="/ayudas/home" routerLinkActive="mat-active" class="menu-link">
          <mat-icon matListIcon>help</mat-icon>
          <p mat-line>
            <span>Ayudas</span>
          </p>
        </a>
      </mat-nav-list>

      <div mat-line class="titulo-seccion-menu" *ngIf="modulesPermissions()">
        <span>Módulos</span>
      </div>
      <!-- Hoja de Vida Institucional -->
      <mat-expansion-panel class="expansion-menu" [expanded]="resumeExpanded"
        *ngIf="getPermission('institutional-resume')">
        <mat-expansion-panel-header [ngClass]="{ expansionExpanded: resumeExpanded }">
          <mat-panel-title>
            <mat-icon matListIcon>description</mat-icon>
            <span class="mat-expansion-title">Hoja de Vida Institucional</span>
          </mat-panel-title>

        </mat-expansion-panel-header>
        <mat-nav-list class="mat-expansion-nav-list">
          <a mat-list-item routerLink="/hoja-vida-institucional/gestor-educativo-sedes"
            routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('institutional-resume','institution_headquarter_management')">

            <span>Gestión de Instituciones <br> y Sedes</span>
          </a>
          <a mat-list-item routerLink="/hoja-vida-institucional/proyecto-educativo"
            routerLinkActive="mat-expansion-active" *ngIf="getPermission('institutional-resume','pei')">
            <span>Proyecto Educativo</span>
          </a>

        </mat-nav-list>
      </mat-expansion-panel>
      <mat-nav-list class="mat-nav-expansion-collapsed expansion-menu-collapsed"
        *ngIf="getPermission('institutional-resume')">
        <a mat-list-item routerLink="." [ngClass]="{ 'mat-active': resumeExpanded }"
          (click)="resumeExpanded = !resumeExpanded">
          <mat-icon matListIcon>description</mat-icon>
        </a>
      </mat-nav-list>
      <!-- End Hoja de Vida Institucional -->

      <!-- Pmtic -->
      <mat-expansion-panel class="expansion-menu" [expanded]="pmticExpanded"
        *ngIf="getPermission('institutional-resume')">
        <mat-expansion-panel-header [ngClass]="{ expansionExpanded: pmticExpanded }">
          <mat-panel-title>
            <mat-icon matListIcon>desktop_windows</mat-icon>
            <span class="mat-expansion-title">PMTIC</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="mat-expansion-nav-list">
          <a mat-list-item *ngIf="getPermission('institutional-resume','institution_headquarter_management')"
            routerLink="/pmtic/plan-de-medios-y-tic" routerLinkActive="mat-expansion-active">
            <span>Plan de Medios y TIC</span>
          </a>
          <a mat-list-item *ngIf="getPermission('institutional-resume','institution_headquarter_management')"
            routerLink="/pmtic/cronograma-y-seguimiento" routerLinkActive="mat-expansion-active">
            <span>Cronograma y Seguimiento</span>
          </a>
          <a mat-list-item *ngIf="getPermission('institutional-resume','institution_headquarter_management') && isAdmin"
            routerLink="/pmtic/ayudas" routerLinkActive="mat-expansion-active">
            <span>Ayudas</span>
          </a>
          <a mat-list-item
            *ngIf="getPermission('institutional-resume','institution_headquarter_management')  && isAdmin"
            routerLink="/pmtic/configuracion" routerLinkActive="mat-expansion-active">
            <span>Configuración</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-nav-list class="mat-nav-expansion-collapsed expansion-menu-collapsed"
        *ngIf="getPermission('institutional-resume')">
        <a mat-list-item routerLink="." [ngClass]="{ 'mat-active': pmticExpanded }"
          (click)="pmticExpanded = !pmticExpanded">
          <mat-icon matListIcon>desktop_windows</mat-icon>
        </a>
      </mat-nav-list>
      <!-- End Plan de Medios y Tic -->

      <!-- Ruta de mejoramiento -->
      <mat-expansion-panel class="expansion-menu" [expanded]="rutaExpanded" *ngIf="getPermission('route')">
        <mat-expansion-panel-header [ngClass]="{ expansionExpanded: rutaExpanded }">
          <mat-panel-title>
            <mat-icon matListIcon>next_plan</mat-icon>
            <span class="mat-expansion-title">Ruta de Mejoramiento</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="mat-expansion-nav-list">
          <a mat-list-item routerLink="/ruta/autoevaluacion" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('route', 'autoevaluation')">
            <span>Autoevaluación</span>
          </a>
          <a mat-list-item routerLink="/ruta/plan" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('route', 'plan')">
            <span>Plan de mejoramiento</span>
          </a>
          <a mat-list-item routerLink="/ruta/seguimiento" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('route', 'tracking')">
            <span>Seguimiento</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-nav-list class="mat-nav-expansion-collapsed expansion-menu-collapsed" *ngIf="getPermission('route')">
        <a mat-list-item routerLink="." [ngClass]="{ 'mat-active': rutaExpanded }">
          <mat-icon matListIcon>next_plan</mat-icon>
        </a>
      </mat-nav-list>
      <!-- End Ruta de mejoramiento -->

      <!-- Gestión de recursos -->
      <mat-expansion-panel class="expansion-menu" [expanded]="recursosExpanded" *ngIf="getPermission('resources')">
        <mat-expansion-panel-header [ngClass]="{ expansionExpanded: recursosExpanded }">
          <mat-panel-title>
            <mat-icon matListIcon>category</mat-icon>
            <span class="mat-expansion-title">Gestión y Administración</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="mat-expansion-nav-list">
          <a mat-list-item routerLink="/recursos/proyectos" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('resources', 'projects')">
            <span>Proyectos</span>
          </a>
          <a mat-list-item routerLink="/recursos/inventario" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('resources', 'inventary')">
            <span>Inventario</span>
          </a>
          <a mat-list-item routerLink="/recursos/reservas" routerLinkActive="mat-expansion-active"
            *ngIf="getPermission('resources', 'reserves')">
            <span>Reservas</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-nav-list class="mat-nav-expansion-collapsed expansion-menu-collapsed" *ngIf="getPermission('resources')">
        <a mat-list-item routerLink="." [ngClass]="{ 'mat-active': recursosExpanded }">
          <mat-icon matListIcon>category</mat-icon>
        </a>
      </mat-nav-list>
      <!-- End Gestión de recursos -->

      <!-- Servicios -->
      <mat-expansion-panel class="expansion-menu" [expanded]="serviciosExpanded">
        <mat-expansion-panel-header [ngClass]="{ expansionExpanded: serviciosExpanded }">
          <mat-panel-title>
            <mat-icon matListIcon>design_services</mat-icon>
            <span class="mat-expansion-title">Servicios</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="mat-expansion-nav-list">
          <mat-expansion-panel class="expansion-menu" [expanded]="menuGestionPedExpanded">
            <mat-expansion-panel-header class="expansionExpanded">
              <mat-panel-title>
                <span class="mat-expansion-title-submenu">Cartillas de gestión pedagógica</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list class="mat-expansion-nav-list">
              <a mat-list-item routerLink="/servicios/gp-progreso-instituciones"
                routerLinkActive="mat-expansion-active">
                <span class="item-list reduce-margin">Progreso de las instituciones</span>
              </a>
              <a mat-list-item routerLink="/servicios/gp-historial-descargas" routerLinkActive="mat-expansion-active">
                <span class="item-list reduce-margin">Historial de descarga</span>
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
          <a mat-list-item routerLink="/servicios/catedra" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">Cátedra de paz</span>
          </a>
          <a mat-list-item routerLink="/servicios/valle-magico" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">Valle mágico</span>
          </a>
          <a mat-list-item routerLink="/servicios/seg-vial" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">Seguridad vial</span>
          </a>
          <a mat-list-item routerLink="/servicios/ppps" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">PPP (Pertenezco)</span>
          </a>
          <a mat-list-item routerLink="/servicios/canvas" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">Canvas</span>
          </a>
          <a mat-list-item routerLink="/servicios/sapere" routerLinkActive="mat-expansion-active">
            <span class="reduce-margin">Sapere Aude</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <!--Manage Documents -->
      <mat-nav-list *ngIf="getPermission('documents')">
        <a mat-list-item routerLink="/documentos/home" routerLinkActive="mat-active" class="menu-link">
          <mat-icon matListIcon>folder_open</mat-icon>
          <p mat-line>
            <span>Documentos</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer"
          href="https://lookerstudio.google.com/embed/u/0/reporting/2dbde1b6-8c06-487a-bb3f-cfd90ea5f662/page/p_jhome6ma3c">
          <mat-icon matListIcon>school</mat-icon>
          <p mat-line>
            <span>Pruebas Saber</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer"
          href="https://lookerstudio.google.com/u/0/reporting/27561644-62fc-4178-92bc-143928c6192c/page/z0dqD?s=q_x8GT5w5h8">
          <mat-icon matListIcon>local_library</mat-icon>
          <p mat-line>
            <span>Test Vocacional - CHASIDE</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer"
          href="https://formacionsigesi.valledelcauca.gov.co">
          <mat-icon matListIcon>cast_for_education</mat-icon>
          <p mat-line>
            <span>Formación Docentes</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer"
          href="https://lookerstudio.google.com/u/0/reporting/62ec8195-ffe0-4154-82bc-cfdf1139595c/page/8bqAE?s=qj7T1_JjIUk">
          <mat-icon matListIcon>science</mat-icon>
          <p mat-line>
            <span>Labspark</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer" href="#"
          (click)="redirectToUrl($event)">
          <mat-icon matListIcon>business</mat-icon>
          <p mat-line>
            <span>Seguridad y Salud en el Trabajo</span>
          </p>
        </a>
      </mat-nav-list>

      <mat-nav-list>
        <a mat-list-item class="menu-link" target="_blank" rel="noopener noreferrer"
          href="https://recursos-socioemocional.sigpruta.co">
          <mat-icon matListIcon>psychology</mat-icon>
          <p mat-line>
            <span>Recursos Socioemocionales</span>
          </p>
        </a>
      </mat-nav-list>

      <div mat-line class="titulo-seccion-menu" *ngIf="getPermission('institutions') || getPermission('users')">
        <span>Administración</span>
      </div>

      <mat-nav-list>
        <a mat-list-item routerLink="/instituciones/home" routerLinkActive="mat-active" class="menu-link"
          *ngIf="getPermission('institutions')">
          <mat-icon matListIcon>foundation</mat-icon>
          <p mat-line>
            <span>Instituciones</span>
          </p>
        </a>
        <a mat-list-item routerLink="/usuarios/home" routerLinkActive="mat-active" class="menu-link"
          *ngIf="getPermission('users')">
          <mat-icon matListIcon>group</mat-icon>
          <p mat-line>
            <span>Usuarios</span>
          </p>
        </a>
      </mat-nav-list>
    </mat-accordion>
  </mat-sidenav>

  <mat-sidenav-content [ngClass]="{ expanded: isExpanded }">
    <mat-toolbar>
      <!-- Menu mobile -->
      <div class="mobileMenu" *ngIf="mobileQuery">
        <button mat-icon-button (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <!-- Menu mobile -->
      <div class="logos-institucionales">
        <img src="assets/images/logos_institucionales.jpg" alt="Logos Institucionales" />
      </div>

      <div class="toolbar-icons">
        <div class="soporte-container">
          <a href="https://api.whatsapp.com/send?phone=+573155109382&text=Necesito%20Soporte%20Sobre%20el%20Sistema%20de%20Informaci%C3%B3n%20de%20Gesti%C3%B3n%20Pedag%C3%B3gica"
            target="_blank" class="link">
            <span>Línea de Soporte</span>
            <img class="soporte-icon" src="assets/images/whatsapp.png" />
          </a>
        </div>

        <div class="redirect-admin" *ngIf="!mobileQuery">
          <button mat-raised-button color="primary" (click)="redirectAdmin()">
            Ir a panel de administración SIGP 1.0
          </button>
        </div>
        <!--<app-notifications [mobileQuery]="mobileQuery"></app-notifications>-->
        <!-- <mat-slide-toggle
					#darkmode
					(change)="changeToggle($event)"
					[checked]="darkMode"
					labelPosition="before"
				>
					<mat-icon title="Cambiar tema">dark_mode</mat-icon>
				</mat-slide-toggle> -->
        <div class="user-avatar">
          <div *ngIf="userAvatar.initials" class="" [style.background-color]="userAvatar.color"
            [matMenuTriggerFor]="menuProfile">
            {{ userAvatar.initials }}
          </div>
        </div>

        <mat-menu #menuProfile>
          <button mat-menu-item routerLink="/perfil">
            <mat-icon>account_circle</mat-icon>
            <span>Perfil</span>
          </button>
          <!-- <a [href]="urlEditProfile" rel="noopener noreferrer">
						<button mat-menu-item>
							<mat-icon>edit_account</mat-icon>
							<span>Editar Perfil</span>
						</button>
					</a> -->
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Salir</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <div class="breadcrumbs-component">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <section class="body">
      <div class="body-container">
        <router-outlet></router-outlet>
      </div>
    </section>
    <footer class="sidenav-footer">Copyright {{ currentYear }}</footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-loading></app-loading>